import {Component, Input} from '@angular/core';
import {AssistantFeedBindingWarning} from '../../../../models/assistant-version.model';

@Component({
  selector: 'app-assistant-feed-binding-warnings',
  standalone: true,
  templateUrl: './assistant-feed-binding-warnings.component.html',
  styleUrl: './assistant-feed-binding-warnings.component.scss'
})
export class AssistantFeedBindingWarningsComponent {
  @Input() warnings: AssistantFeedBindingWarning[] = [];

  trackWarning(_: number, warning: AssistantFeedBindingWarning): string {
    return `${warning.code}:${warning.chatbotId ?? ''}:${warning.productFeedIds?.join(',') ?? ''}`;
  }
}
